import axios from "axios";

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_BACKEND,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 400 &&
      error.response?.data?.message?.includes("Organizer profile setup is required")
    ) {
      window.location.href = "/organizer";
    }
    return Promise.reject(error);
  }
);

const getRequest = ({
  path,
  params = {},
  config = {},
  success,
  error,
  final,
}) => {
  const finalConfig = {
    ...config,
    params, // Inject query parameters dynamically
  };

  axiosInstance
    .get(path, finalConfig)
    .then(success)
    .catch(error)
    .finally(final);
};

const postRequest = (data) => {
  const { path, payload, config, success, error, final } = data;
  axiosInstance
    .post(path, payload, config)
    .then(success)
    .catch(error)
    .finally(final);
};
const postPdfRequest = (data) => {
  const { path, payload, config = {}, success, error, final } = data;
  axiosInstance
    .post(path, payload, { ...config, headers: { Accept: "application/pdf" } })
    .then(success)
    .catch(error)
    .finally(final);
};
const putRequest = (data) => {
  const { path, payload, success, error, config, final } = data;
  axiosInstance
    .put(path, payload, config)
    .then(success)
    .catch(error)
    .finally(final);
};

const patchRequest = (data) => {
  const { path, payload, success, error, config, final } = data;
  axiosInstance
    .patch(path, payload, config)
    .then(success)
    .catch(error)
    .finally(final);
};

const deleteRequest = (data) => {
  const { path, payload, success, error, final } = data;
  axiosInstance
    .delete(path, { data: payload })
    .then(success)
    .catch(error)
    .finally(final);
};

export default {
  getRequest,
  postRequest,
  postPdfRequest,
  patchRequest,
  putRequest,
  deleteRequest,
};
